import { getCalculatorClient } from 'services/FionaAPI/Calculator/client'
import { createDataWrapper } from 'components/patterns/suspense/internals/DataWrapper'
import type { DebtConsolidationCalcResult } from 'generated/api/models'
import type { DebtConsolidationControllerGetDebtConsolidationCalculationResultCreditScoreEnum } from 'generated/api/apis/DebtConsolidationControllerApi'
import { DataWrapper } from 'components/patterns/suspense/internals/types'

interface CalculatorProps {
	currentDebt: number
	currentMonthlyPayment: number
	currentApr: number
	creditScore: DebtConsolidationControllerGetDebtConsolidationCalculationResultCreditScoreEnum
	zipcode: string
}

export const useCalculatorLoansPreview = (props: CalculatorProps): DataWrapper<DebtConsolidationCalcResult> => {
	return createDataWrapper(() => getCalculatorClient().getCalculationResult(props))
}
